<template>
    <LoginDialog></LoginDialog>
</template>

<script>
 import LoginDialog from './LoginDialog.vue'

 export default {
     name: 'Login',
     props: {
     },
     components: {
         LoginDialog
     }
 }
</script>

<style scoped>
</style>
